<mat-toolbar style="background-color:#5775a8; min-height: 100px; max-height: 100px">
  <button mat-icon-button class="matero-toolbar-button" aria-label="open sidebar menu" name="open sidebar menu"
    *ngIf="(!environment.collapsibleSidebar || sharedService.mobile) && environment.displaySidebar && isAuthenticated()"
    (click)="toggleSidenav.emit()">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="flex justify-center">

    <div class="flex justify-center">
      <a href="http://www.oregon.gov/oha/ph/pages/index.aspx" target="_blank" title="Oregon Health Authority">
        <img src="../../../assets/images/OHA-Color-min.png"
          style="width: 198px; height: 75px;" alt="Indoor Clean Air Act - Tobacco Prevention and Education Program" />        
      </a>

      <div class="flex items-center">

        <span class="p-l-16">
          <a href="http://public.health.oregon.gov/PreventionWellness/TobaccoPrevention/SmokefreeWorkplaceLaw/Pages/index.aspx"
            target="_blank" class="navbar-brand" title="Oregon's Indoor Clean Air Act" style="color: white;">
            Indoor Clean Air Act
            <br>
            Tobacco Prevention and Education Program
          </a>
        </span>

      </div>
    </div>

    <div class="float-right">
      <app-translate *ngIf="environment.translateText"></app-translate>
    </div>

  </div>

  <app-translate *ngIf="environment.translateText"></app-translate>

  <div class="flex flex-row gap-4 absolute right-4">
    <button mat-icon-button *ngIf="!isAuthenticated()" (click)="login()" class="matero-toolbar-button"
      aria-label="Login" matTooltip="Login" matTooltipPosition="below" [matTooltipShowDelay]="750">
      <mat-icon class="dark-theme-icon">login</mat-icon>
    </button>

    <div *ngIf="isAuthenticated()" class="flex flex-row justify-start items-center m-r-8">
      <button mat-button [matMenuTriggerFor]="userMenu"><span class="f-s-20">{{ username }}</span>
        <mat-icon>expand_more</mat-icon>
      </button>
    </div>

    <mat-menu #userMenu="matMenu">
      <button mat-menu-item *ngIf="environment.showThemeToggle && sharedService.darkMode" class="matero-toolbar-button"
        (click)="toggleTheme()" aria-label="Toggle Theme" matTooltip="Select Light Theme" matTooltipPosition="below"
        [matTooltipShowDelay]="750">
        <span class="p-r-8">Toggle Theme</span>
        <mat-icon class="light-theme-icon">brightness_7</mat-icon>
      </button>

      <button mat-menu-item *ngIf="environment.showThemeToggle && !sharedService.darkMode" class="matero-toolbar-button"
        (click)="toggleTheme()" aria-label="Toggle Theme" matTooltip="Select Dark Theme" matTooltipPosition="below"
        [matTooltipShowDelay]="750">
        <span class="p-r-8">Toggle Theme</span>
        <mat-icon class="dark-theme-icon">brightness_3</mat-icon>
      </button>

      <button mat-menu-item *ngIf="isAuthenticated()" (click)="logout()" class="matero-toolbar-button"
        aria-label="Logout" matTooltip="Logout" matTooltipPosition="below" [matTooltipShowDelay]="750">
        <span class="m-r-16">Sign-Out</span>
        <mat-icon>logout</mat-icon>
      </button>

    </mat-menu>
  </div>
</mat-toolbar>